export const TOGGLE_LOADING = 'oppv/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'oppv/TOGGLE_SUCCESS'
export const OPPV = 'oppv/OPPV'
export const ERROR = 'oppv/ERROR'
export const RESET = 'oppv/RESET'
